module.exports = __webpack_public_path__ + "static/media/only_notes.e713146f.svg";